module.exports = __webpack_public_path__ + "img/card02.6ca43bc3.png";